import React from "react";
import { Icon, Message, Popup } from "semantic-ui-react";
import "./_HelpField.less";

interface HelpFieldProps {
  id: string;
  helpText?: string;
}

/**
 * @return {null}
 */
const HelpField: React.FC<HelpFieldProps> = ({
  helpText,
  id
}) => {

  if (helpText) {
    return (
      <Popup
        on={["click", "hover"]}
        content={helpText}
        position="top right"
        style={{ maxWidth: "400px" }}
        flowing
        trigger={(
          <Icon
            className="sui-help-icon"
            style={{ position: "absolute", top: 0, right: 0 }}
            name="info"
            color="blue"
            size="small"
            circular
          />
        )}
      />
    );
  }
  if (helpText) {
    return <Message size="mini" info id={id} content={helpText} />;
  }
  return null;
};

export default HelpField;
